/*
 * Dryer Sheets LP — shared purchase behaviour.
 * - [data-ctr-dryer-card]: product card with optional one-time / subscribe toggle.
 * - [data-ctr-dryer-atc]: add-to-cart button. Reads variant + selling plan from its card
 *   (or from its own data attributes when used standalone, e.g. the Trio banner).
 * Uses the existing sidecart flow (window.openSidecart / window.fetchCart).
 */
(function () {
  if (window.ctrDryerLpInit) return;
  window.ctrDryerLpInit = true;

  function setPurchaseOption(card, option) {
    card.setAttribute('data-purchase-option', option);
    card.querySelectorAll('[data-ctr-dryer-option]').forEach(function (el) {
      var isActive = el.getAttribute('data-ctr-dryer-option') === option;
      el.classList.toggle('is-active', isActive);
      el.setAttribute('aria-checked', isActive ? 'true' : 'false');
    });
  }

  function buildItem(button) {
    var card = button.closest('[data-ctr-dryer-card]');
    var source = card || button;
    var variantId = parseInt(source.getAttribute('data-variant-id'), 10);
    if (!variantId) return null;

    var option = source.getAttribute('data-purchase-option') || 'one_time';
    var sellingPlanId = parseInt(source.getAttribute('data-selling-plan-id'), 10);
    var item = { id: variantId, quantity: 1, properties: {} };

    if (option === 'subscription' && sellingPlanId) {
      item.selling_plan = sellingPlanId;
      delete item.properties;
    } else {
      item.properties['Purchase Type'] = 'One Time';
    }
    return item;
  }

  function addToCart(button) {
    if (button.classList.contains('is-loading')) return;
    var item = buildItem(button);
    if (!item) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] }),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || 'Unknown cart error');
          });
        }
        return response.json();
      })
      .then(function () {
        if (window.openSidecart) {
          window.openSidecart();
          if (window.fetchCart) window.fetchCart();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        alert(err.message || err);
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      });
  }

  /*
   * Keep the scroll position while the sidecart is open. Sidecart locks the page with
   * body.no-scroll (position: fixed, no offset), which jumps to the top. Scoped to pages
   * that load this script, so the site-wide sidecart behaviour is unchanged.
   */
  (function preserveScrollOnSidecart() {
    var body = document.body;
    var lastScrollY = window.scrollY;
    var lockedAt = null;

    window.addEventListener('scroll', function () {
      if (lockedAt === null) lastScrollY = window.scrollY;
    }, { passive: true });

    new MutationObserver(function () {
      var isLocked = body.classList.contains('no-scroll');
      if (isLocked && lockedAt === null) {
        lockedAt = lastScrollY;
        body.style.top = -lockedAt + 'px';
      } else if (!isLocked && lockedAt !== null) {
        var restoreY = lockedAt;
        lockedAt = null;
        body.style.top = '';
        window.scrollTo({ top: restoreY, behavior: 'instant' });
      }
    }).observe(body, { attributes: true, attributeFilter: ['class'] });
  })();

  document.addEventListener('click', function (event) {
    var option = event.target.closest('[data-ctr-dryer-option]');
    if (option) {
      var card = option.closest('[data-ctr-dryer-card]');
      if (card) setPurchaseOption(card, option.getAttribute('data-ctr-dryer-option'));
      return;
    }

    var button = event.target.closest('[data-ctr-dryer-atc]');
    if (button) {
      event.preventDefault();
      addToCart(button);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var option = event.target.closest('[data-ctr-dryer-option]');
    if (!option) return;
    event.preventDefault();
    option.click();
  });
})();
